import Phaser from 'phaser';

export default class RandomValuePool {
  constructor(values) {
    this.values = JSON.parse(JSON.stringify(values));
    this.setup();
  }

  setup () {
    this.restart();
  }

  getValue () {
    if (this.pool.length <= 0) {
      this.restart();
    }
    return this.pool.pop();
  }

  restart () {
    this.pool = JSON.parse(JSON.stringify(this.values));
    Phaser.Utils.Array.Shuffle(this.pool);
  }
}